// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Utils
import { listSeparator } from '../../../../../../../common/utils/stringUtil';
import { getGivenName } from '../../../../../../../common/users/userHelper';

const UserNames = ({ users }) => (
    <span className="UserNames">
        {users.length
            ? users.map((user, index, self) => {
                  const separator = listSeparator(index, self.length);
                  return (
                      <span key={index}>
                          <span className="name">{getGivenName(user)}</span>
                          {separator}
                      </span>
                  );
              })
            : 'Someone'}
    </span>
);

UserNames.propTypes = {
    users: PropTypes.array,
};

export default UserNames;
